/* SHALEM — capa CRO (depurada 2026-10-21)

   Esta capa nacio para parchear en el navegador un markup anterior
   (.shalem-frag-btn, .shalem-pack-opcion, .shalem-top-score...). Ese markup
   ya no existe: hoy la seccion usa .shalem-aroma-pill y .shalem-pack-v2-opcion.
   Se verifico con el DOM en vivo que estas funciones no encontraban nada:

     preseleccionar()   -> .shalem-frag-btn            0 elementos
     swatches()         -> .shalem-frag-texto          0 elementos
     precioPorFrasco()  -> .shalem-pack-opcion-precio  0 elementos
     corregirCopy()     -> .shalem-top-score           0 elementos
                        -> .shalem-frag-surtido-nota   0 elementos
                        -> .shalem-pack-opcion-contenido 0 elementos

   Corrian en cada carga, recorrian todos los <p> de la pagina y no cambiaban
   nada: puro trabajo de main thread. Se eliminaron.

   El texto de #shalem-urgency, que antes se reescribia aqui, ahora se
   renderiza directo en el Liquid: reescribirlo por JS causaba un cambio de
   layout despues de cargar.

   Queda solo lo que sigue vivo y es necesario. */
(function () {
  'use strict';

  /* ───── 1. Reubicar los CTA de cierre ─────
     La seccion shalem-cierre se renderiza dentro de un pool oculto y desde
     aqui se mueve a sus dos destinos reales. Es el unico motivo por el que
     este archivo sigue existiendo. */

  function reubicarCierres() {
    var pool = document.querySelector('[data-shalem-cierre-pool]');
    if (!pool) return;

    var aGarantia = pool.querySelector('[data-shalem-cierre-destino="garantia"]');
    var aFinal = pool.querySelector('[data-shalem-cierre-destino="final"]');

    var garantia = document.querySelector('.shalem-garantia30');
    if (aGarantia && garantia && garantia.parentNode) {
      garantia.parentNode.insertBefore(aGarantia, garantia);
    }

    var footer = document.querySelector('.shalem-footer2');
    if (aFinal && footer && footer.parentNode) {
      footer.parentNode.insertBefore(aFinal, footer);
    }

    if (pool.parentNode) pool.parentNode.removeChild(pool);
  }

  /* ───── 2. Los CTA de cierre disparan el boton real de compra ───── */

  function botonPrincipal() {
    return document.querySelector('[data-shalem-submit]');
  }

  function zonaSelector() {
    return document.getElementById('shalem-target-fragancia') ||
           document.getElementById('shalem-target-pack');
  }

  function alClic(e) {
    var t = e.target;
    var btn = null;
    while (t && t !== document) {
      if (t.hasAttribute && t.hasAttribute('data-shalem-cierre-atc')) { btn = t; break; }
      t = t.parentNode;
    }
    if (!btn) return;
    e.preventDefault();

    var principal = botonPrincipal();
    if (principal && !principal.disabled) { principal.click(); return; }

    var zona = zonaSelector();
    if (zona) zona.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* ───── 3. Iconos de pago (reemplaza emoji por SVG) ───── */

  var SVG_EFECTIVO = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#1A110A" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/><path d="M6 12h.01M18 12h.01"/></svg>';
  var SVG_ENTREGA = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#1A110A" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5v-9Z"/><path d="m3 7.5 9 4.5 9-4.5"/><path d="M12 12v9"/></svg>';

  function iconosPago() {
    var items = document.querySelectorAll('.shalem-pago-icono-item');
    for (var i = 0; i < items.length; i++) {
      var emoji = items[i].querySelector('.shalem-pago-icono');
      if (!emoji) continue;
      var label = items[i].querySelector('.shalem-pago-icono-label');
      var texto = label ? label.textContent : '';
      var envoltura = document.createElement('span');
      envoltura.innerHTML = texto.indexOf('Contra') !== -1 ? SVG_ENTREGA : SVG_EFECTIVO;
      emoji.parentNode.replaceChild(envoltura.firstChild, emoji);
    }
  }

  /* ───── Arranque ───── */

  function init() {
    document.addEventListener('click', alClic, false);
    reubicarCierres();
    iconosPago();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
